/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Swap_Later_RowInputs */

const en_us2_workout_swap_later_row = /** @type {(inputs: Workout_Swap_Later_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Later`)
};

const pt_br2_workout_swap_later_row = /** @type {(inputs: Workout_Swap_Later_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depois`)
};

const es_419_workout_swap_later_row = /** @type {(inputs: Workout_Swap_Later_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Después`)
};

const pt_pt2_workout_swap_later_row = /** @type {(inputs: Workout_Swap_Later_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depois`)
};

const fr_fr2_workout_swap_later_row = /** @type {(inputs: Workout_Swap_Later_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus tard`)
};

const de_de2_workout_swap_later_row = /** @type {(inputs: Workout_Swap_Later_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Später`)
};

const it_it2_workout_swap_later_row = /** @type {(inputs: Workout_Swap_Later_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dopo`)
};

/**
* | output |
* | --- |
* | "Later" |
*
* @param {Workout_Swap_Later_RowInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_swap_later_row = /** @type {((inputs?: Workout_Swap_Later_RowInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Swap_Later_RowInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_swap_later_row(inputs)
	if (locale === "es-419") return es_419_workout_swap_later_row(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_swap_later_row(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_swap_later_row(inputs)
	if (locale === "de-DE") return de_de2_workout_swap_later_row(inputs)
	if (locale === "it-IT") return it_it2_workout_swap_later_row(inputs)
	return en_us2_workout_swap_later_row(inputs)
});
export { workout_swap_later_row as "workout-swap.later_row" }